exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#CurveDetail .v--modal-box.v--modal{min-height:350px!important;min-width:400px!important}#CurveDetail .v-card.v-card--flat.v-sheet.theme--light{height:100%!important}#CurveDetail .current-curve__header{font-size:15px;font-weight:500}#CurveDetail .header__text--center{text-align:center}#CurveDetail .header__first-row{line-height:68px}#CurveDetail .full-height{height:90%}#CurveDetail .v-input{font-size:12px}#CurveDetail .chartContainer{width:100%;height:90%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5bc348c4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/modelWat/modals/CurveDetail.vue
// module id = 1860
// module chunks = 0